module.exports = __webpack_public_path__ + "static/media/fh-logo.fb5a926d.svg";